import {SystemBaseApi} from "./SystemBaseApi";
import {Methods} from "@newview/infrastructure";

/**
 * Api
 */
export class ProjectsubsystemrelationApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'projectsubsystemrelation'
    }

    /**
     * 查询列表
     * @returns
     */
    public getList(projectId){
        return this.send({projectId: projectId},"getList",Methods.GET)
    }

    /**
     * 项目id查询子系统列表
     * @param projectId 
     */
    public getSystemByProjectId(projectId){
        return this.send({projectId: projectId},"getSystemByProjectId",Methods.GET)
    }


   
}